/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesPaymentRefundReason } from './WebApiModelsEnumerationTypesPaymentRefundReason';
import {
    WebApiModelsEnumerationTypesPaymentRefundReasonFromJSON,
    WebApiModelsEnumerationTypesPaymentRefundReasonFromJSONTyped,
    WebApiModelsEnumerationTypesPaymentRefundReasonToJSON,
} from './WebApiModelsEnumerationTypesPaymentRefundReason';
import type { WebApiModelsEnumerationTypesPaymentRefundStatus } from './WebApiModelsEnumerationTypesPaymentRefundStatus';
import {
    WebApiModelsEnumerationTypesPaymentRefundStatusFromJSON,
    WebApiModelsEnumerationTypesPaymentRefundStatusFromJSONTyped,
    WebApiModelsEnumerationTypesPaymentRefundStatusToJSON,
} from './WebApiModelsEnumerationTypesPaymentRefundStatus';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoExternalPaymentRefundDto
 */
export interface WebApiIntegrationsDtoExternalPaymentRefundDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    externalPaymentId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    externalRefundId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    currency?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesPaymentRefundReason}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    reason?: WebApiModelsEnumerationTypesPaymentRefundReason;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesPaymentRefundStatus}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    status?: WebApiModelsEnumerationTypesPaymentRefundStatus;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    message?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebApiIntegrationsDtoExternalPaymentRefundDto
     */
    updatedAt?: Date | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoExternalPaymentRefundDto interface.
 */
export function instanceOfWebApiIntegrationsDtoExternalPaymentRefundDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoExternalPaymentRefundDtoFromJSON(json: any): WebApiIntegrationsDtoExternalPaymentRefundDto {
    return WebApiIntegrationsDtoExternalPaymentRefundDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoExternalPaymentRefundDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoExternalPaymentRefundDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'externalPaymentId': !exists(json, 'externalPaymentId') ? undefined : json['externalPaymentId'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'externalRefundId': !exists(json, 'externalRefundId') ? undefined : json['externalRefundId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'reason': !exists(json, 'reason') ? undefined : WebApiModelsEnumerationTypesPaymentRefundReasonFromJSON(json['reason']),
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesPaymentRefundStatusFromJSON(json['status']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
    };
}

export function WebApiIntegrationsDtoExternalPaymentRefundDtoToJSON(value?: WebApiIntegrationsDtoExternalPaymentRefundDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'externalPaymentId': value.externalPaymentId,
        'memberId': value.memberId,
        'externalRefundId': value.externalRefundId,
        'amount': value.amount,
        'currency': value.currency,
        'reason': WebApiModelsEnumerationTypesPaymentRefundReasonToJSON(value.reason),
        'status': WebApiModelsEnumerationTypesPaymentRefundStatusToJSON(value.status),
        'description': value.description,
        'message': value.message,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
    };
}

